(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('FavoritesController', FavoritesController);

    FavoritesController.$inject = ['$scope', '$state', '$rootScope', '$sce', '$translate', '$injector', 'FavoritesService'];

    function FavoritesController($scope, $state, $rootScope, $sce, $translate, $injector, FavoritesService) {
        var vm = this;
        var selectedFavorite = null;
        vm.favoriteUserList = [];
        vm.requestRunning = false;
        vm.view = {};
        vm.view.tooltip = '';

        function initialize() {
            vm.requestRunning = true;
            // There is no error callback because the possible errors are already catched by the global error interceptor
            FavoritesService.getFavorites().then(successUserFavorites);
            getTooltip();
        }
        initialize();

        function getTooltip() {
            translateTooltip();
            var translateChangeListener = $rootScope.$on('$translateChangeSuccess', translateTooltip);
            $rootScope.$on('$destroy', translateChangeListener);
        }

        function translateTooltip() {
            $translate('tooltip.addFavorite').then(function (translation) {
                vm.view.tooltip = $sce.trustAsHtml(translation);
            });
        }

        $scope.$on('favoritesSaved', initialize);

        function successUserFavorites(data) {
            vm.favoriteUserList = data;
            vm.requestRunning = false;
        }

        vm.addFavorite = function () {
            FavoritesService.addFavoriteModalConstructor($scope);
        }

        vm.removeFavoriteItem = function (favorite) {
            selectedFavorite = favorite.id;
            FavoritesService.deleteFavoriteModalConstructor(favorite, $scope);
        }

        $scope.$on('favoriteDeleted', successDelete);

        function successDelete() {
            vm.favoriteUserList.forEach(function (item, index) {
                if (item.id == selectedFavorite) {
                    vm.favoriteUserList.splice(index, 1);
                }
            });
            selectedFavorite = null;
        }

        vm.openFavorite = FavoritesService.openFavorite;
    }
})();